import React, { Fragment, useEffect, useState } from 'react';
import { Row, Col, Form, Button, message, Input } from 'antd';
import { useAddAlertList, useAlertlist } from 'hooks/configuration/tag/tag';
import "../style.css";
import TableStateRow from "components/tableState";
import { PAGES, ACTIONS, usePermissions } from "hooks/permissions/permissions";

const Alerts = () => {

    const { can } = usePermissions();
    // Saving replaces the whole recipient list, so it has always needed both ADD and EDIT.
    const canSave = can(PAGES.ALERT, ACTIONS.ADD) && can(PAGES.ALERT, ACTIONS.EDIT);

    const [form] = Form.useForm();
    const [email, setEmail] = useState(null);

    const { data: alertData, refetch } = useAlertlist();
    const { mutate: alert } = useAddAlertList();

    const validateEmailList = (rule, value, callback) => {
        const emails = value.split(',').map((email) => email.trim());
        const invalidEmails = emails.filter((email) => {
            const regex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
            return email !== '' && !regex.test(email);
        });
        setEmail(emails);
        if (invalidEmails.length > 0) {
            callback('Please enter valid email address: ' + invalidEmails.join(', '));
        } else {
            callback();
        }
    };

    const onFinish = () => {
        let multiEmail = { "email": email }
        alert(multiEmail, {
            onSuccess: (item) => {
                if (item?.statusCode === 200) {
                    refetch();
                    message.success(item?.data)

                } else {
                    message.error(item?.message);
                }
            },
            onError: (error) => {
                message.error(error);
            }
        })
    }

    const emptyField = () => { form.setFieldsValue({ "email": "", }); }

    useEffect(() => {
        form.setFieldsValue({
            "email": alertData?.data?.emails,
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [alertData])


    useEffect(() => {
        refetch();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (
        <Fragment>
            <div className="alert-head">
                <Row>
                    <Col md={12} xs={24}>
                        <h1>Key Personnel Mail IDs</h1>
                        <p>Update Key Personnel Mail IDs</p>
                        <Form name="basic" form={form} onFinish={onFinish} autoComplete="off" layout="vertical">
                            <Form.Item
                                name="email"
                                label=" "
                                rules={[{ required: true, message: 'Please enter email address' }, { validator: validateEmailList }]}
                            >
                                <Input.TextArea disabled={!canSave} rows={6} placeholder="Enter email addresses separated by commas" />
                            </Form.Item>
                            <span className="comma">Seperate each mail ids by comma(,)</span>
                            {!canSave ? null :
                                <div className="key-personal">
                                    <Form.Item>
                                        <Button type="cancel" onClick={emptyField}>
                                            Cancel
                                        </Button>
                                    </Form.Item>
                                    <Form.Item>
                                        <Button type="primary" htmlType="submit">
                                            Save
                                        </Button>
                                    </Form.Item>
                                </div>}
                        </Form>
                    </Col>
                    <Col md={2} />
                    <Col md={10}>
                        {/* The guard here tested a misspelled property, so it
                            was always undefined and never equal to 0 -- the
                            table rendered even with no recipients, showing a
                            bare header. It now keeps the table and says what is
                            missing, which is more use than hiding it. */}
                        <div className="common-table">
                            <table>
                                <thead>
                                    <tr>
                                        <th>Email Id</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {!alertData?.data?.emailListDto?.length ? (
                                        <TableStateRow colSpan={1}>
                                            No recipients added yet
                                        </TableStateRow>
                                    ) : alertData?.data?.emailListDto?.map((item, a) => (
                                        <tr key={a}>
                                            <td>{item?.emails}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </Col>
                </Row>
            </div>
        </Fragment>
    )
}

export default Alerts;
